import { AppEnum, AppEnumHelper, DateFormatHelper, OptionHelper, PublicationEnums, RecordMap } from "@/Shared";

import { PublicationModel } from "../Models/PublicationModel";
import { PublicationFormValues } from "../PublicationFormValidation";
import { UserModel } from "@/Domains/User";
import { PropertyModel } from "@/Domains/Property";



export interface PublicationFVMParams {
    viewEnums: PublicationEnums,
    publication?: PublicationModel,
    userMap : RecordMap<UserModel>,
    propertyMap : RecordMap<PropertyModel>,
    property? : PropertyModel
}


export class PublicationFormViewModel {

    private _publication? : PublicationModel;
    private _property? : PropertyModel;
    private _userOptions! : AppEnum[];
    private _propertyOptions! : AppEnum[];
    private _typeOptions! : AppEnum[];
    private _categoryOptions! : AppEnum[];
    
    public constructor(protected params: PublicationFVMParams) {

        const { viewEnums, userMap, publication, propertyMap, property } = params;

        this._publication = publication;
        this._property = property;
        this._userOptions = OptionHelper.userOptions(userMap.toArray());
        this._propertyOptions = OptionHelper.propertyOptions(propertyMap.toArray(), viewEnums.PropertyTypeEnum);
        this._categoryOptions = OptionHelper.sortByLabel(this.params.viewEnums.AdSourceCategoryEnum);
        this.handleCategoryChange(this._publication?.adSourceCategory);
    }

    handleCategoryChange(newValue? : string) {
        
        const newTypes = AppEnumHelper.getByValue(this.params.viewEnums.AdSourceCategoryEnum, newValue)?.children;
        
        this._typeOptions = newTypes ? OptionHelper.sortByLabel(newTypes) : [];
        return this._typeOptions?.[0]?.value;
    }

    get formValues(): PublicationFormValues {
        return {
            adSourceType: this._publication?.adSourceType || "",

            adSourceCategory: this._publication?.adSourceCategory || "",

            propertyId: this._property?.id ?? this._publication?.propertyId ?? null,

            firstPostedAt:  DateFormatHelper.toInput(this._publication?.firstPostedAt),

            endPostedAt: DateFormatHelper.toInput(this._publication?.endPostedAt),

            firstPostedBy: this._publication?.firstPostedBy ?? null,

            endPostedBy: this._publication?.endPostedBy ?? null,

            note: this._publication?.note || "",
        };
    }

    get userOptions(){
        return this._userOptions;
    }

    get propertyOptions(){
        return this._propertyOptions;
    }

    get categoryOptions(): AppEnum[] {
        return this._categoryOptions;
    }

    get typeOptions(): AppEnum[] {
        return this._typeOptions;
    }

    getTitle = () => {
        return this._publication 
        ? "Annonce N° " + this._publication.id + " - " + this._publication?.adSourceCategory?.toUpperCase() 
        : "Création de bien";
    }

    isCreationMode = () => !this._publication?.id;
}